const SolutionSection = () => {
  return (
    <section className="w-full bg-white py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* TITLE */}
        <div className="max-w-3xl mx-auto mb-20 text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 whitespace-nowrap">
            Servicio de eficiencia energética
          </h2>

          {/* Subtítulo */}
          <p className="mt-4 text-lg text-slate-600 whitespace-nowrap">
            Convierte datos eléctricos en acciones concretas para reducir tu factura.
          </p>
        </div>

        <div className="grid md:grid-cols-[1fr_1.3fr] gap-10 items-center">

          {/* LEFT - BENEFITS */}
          <div>
            <div className="grid gap-6 max-w-md">

              {/* Card 1 */}
              <div className="bg-[#FDE6C8] rounded-xl p-6 border border-[#F5A524]/30 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
                <div className="h-1.5 w-12 bg-[#F5A524] rounded-full mb-4" />
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  Anticipación
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Detectas momentos críticos antes de que impacten tu factura.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-[#FDE6C8] rounded-xl p-6 border border-[#F5A524]/30 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
                <div className="h-1.5 w-12 bg-[#F5A524] rounded-full mb-4" />
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  Decisiones claras
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Sabes cuándo actuar, sin interpretar datos complejos.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-[#FDE6C8] rounded-xl p-6 border border-[#F5A524]/30 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all">
                <div className="h-1.5 w-12 bg-[#F5A524] rounded-full mb-4" />
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  Operación intacta
                </h3>
                <p className="text-slate-700 leading-relaxed">
                  Reduces el costo sin detener la producción.
                </p>
              </div>

            </div>
          </div>

          {/* RIGHT - IMAGE */}
          <div className="relative -mr-24 md:-mr-32">
            <img
              src="/platform-sergen.png"
              alt="Plataforma SERGEN - monitoreo energético"
              className="w-full h-auto object-contain"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
